module.exports = __webpack_public_path__ + "img/belgium-eye-and-ear-diseases-male.1c76e000.png";